/**
 * @file 产品使用场景概览的tab，会根据列表数据自动判断
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo, useState} from 'react';
import {Row, Tabs} from 'antd';
import Icon from '@ant-design/icons';
import {TabsProps} from 'antd/es/tabs';

import ProductCard from './ProductCard';

import {IProductPreviewGroupTabItem} from '../../types';

import {ReactComponent as PreTrainingModeUtility} from './image/PreTrainingModeUtility.svg';
import {ReactComponent as DevTools} from './image/DevTools.svg';
import {ReactComponent as ModelBase} from './image/ModelBase.svg';

interface IPTabsProps extends TabsProps {
    tabs: IProductPreviewGroupTabItem[];
}

const PTabs: React.FC<IPTabsProps> = (props) => {
    const tabs = props.tabs;
    const [activeKeyState, setActiveKeyState] = useState<string>();

    const defaultActiveKey = useMemo(() => {
        return tabs.find(tab => tab.defaultShow)?.title;
    }, [tabs]);

    useMemo(() => {
        setActiveKeyState(defaultActiveKey);
    }, [defaultActiveKey]);

    return (
        <Tabs
            activeKey={activeKeyState}
            {...props}
        >
            {tabs.map((tab) => (
                <Tabs.TabPane
                    tab={
                        <div onMouseEnter={() => setActiveKeyState(tab.title)}>
                            {tab.icon === 'PreTrainingModeUtility'
                            && (
                                <Icon component={PreTrainingModeUtility} />
                            )}
                            {tab.icon === 'DevTools'
                            && (
                                <Icon component={DevTools} />
                            )}
                            {tab.icon === 'ModelBase'
                            && (
                                <Icon component={ModelBase} />
                            )}
                            {tab.title}
                        </div>
                    }
                    key={tab.title}
                >
                    <Row className="paddle-psp-step-product-list clear-both">
                        {tab.list.map((product, index, thisArr) => (
                            <ProductCard
                                key={`${product.title}${product.text}${product.extraText}`}
                                {...product}
                            />
                        ))}
                    </Row>
                </Tabs.TabPane>
            ))}
        </Tabs>
    );
};

export default PTabs;
